import { Box, Grid } from '@mui/material';
import React from 'react';
import { SparkEditableText } from 'sharedComponents/UI';

type BoardNodeHeaderProps = {
  title: string;
  onTitleSave: (newValue: string) => void;
  isReadOnlyMode?: boolean;
};
const BoardNodeHeader = ({
  title,
  isReadOnlyMode,
  onTitleSave,
}: BoardNodeHeaderProps) => {
  return (
    <Grid
      item
      container
      alignItems='center'
      justifyContent='space-between'
      flexWrap='nowrap'
      bgcolor='white'
      padding={1}
      paddingX={2}
      borderRadius='10px 10px 0 0'
      className='drag-handle'
      position='relative'
      sx={{ pointerEvents: 'all' }}
    >
      <SparkEditableText
        initialText={title}
        disabled={isReadOnlyMode}
        onTextChange={onTitleSave}
        placeholder='Untitled'
      />
    </Grid>
  );
};

export default BoardNodeHeader;
